import React from 'react';
import PropTypes from 'prop-types';
import Logo from "../pages/Manpower_Logo3.png";
import "./MainCopy.css";

const MainCopy = ({
  selectedItemMax = 1,
}) => {
  return (
    <>
      <img src={Logo} alt="Logo" className="logo-vero" />
      <h1 className="form-title">Program CTA - DIRITTO MIRATO</h1>
      <div className="form-description container-par">
        <p style={{ textAlign: "center" }}>
          Gentile Collega, scegli i tuoi migliori ex lavoratori che non vuoi lasciare ai competitor!
          Se non hai un’altra opportunità di lavoro da proporgli prontamente, iscrivilo al nuovo percorso di
        </p>
        <h2 className="form-title">Diritto Mirato – Program CTA!</h2>
        <p>
          L’iscrizione è semplice e permette al lavoratore di avere:
        </p>
        <ul>
          <li>Un’opportunità di riqualificazione e aggiornamento professionale gratis</li>
          <li>Un’indennità durante il percorso formativo di € 420,00 lorde se frequenta interamente il corso di 120h</li>
          <li>Maggiore possibilità di reinserimento nel mercato del lavoro.</li>
        </ul>
        <p>
          Per procedere con l’iscrizione:
        </p>
        <ol>
          <li>Inserisci tutti i dati nei campi sottostanti. Ciascun campo deve essere compilato in maniera precisa e puntale (informazioni errate e/o non corrette non permettono l’accesso alla misura) </li>
          <li>
            Allega:
            <ul>
              <li>Il patto di servizio firmato dal ex lavoratore</li>
              <li>I cedolini paga che attestano i 45 giorni lavorati nei 12 mesi precedenti</li>
              <li>La Did o C2 Storico che attesta il suo attuale status di disoccupato</li>
            </ul>
          </li>
          <li>Fai scegliere al ex lavoratore il corso a cui vuole aderire tra i titoli presenti nel forms.
          Il corso ha una durata di 120 ore, 8 ore al giorno e si svolge in modalità virtuale sincrona.</li>
        </ol>
      </div>
    </>
  );
};

MainCopy.propTypes = {
  selectedItemMax: PropTypes.number,
};

export default MainCopy;